/**
 * Shared read of the global curated lists (Feature 096).
 * Own query key so professional surfaces load curated content lazily and
 * independently of their host queries. The care-seeker My Team page keeps its
 * favorites-nested key (see features/favorites) so favorite mutations there
 * still refetch curated save-state.
 */

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/core/api/client';
import type { CuratedContent } from './types';

export const curatedContentKey = ['curated-content'] as const;

export const getCuratedContent = async (): Promise<CuratedContent> => {
  const response = await apiClient.get<CuratedContent>('/curated');
  return response.data;
};

export const useCuratedContent = () =>
  useQuery({ queryKey: curatedContentKey, queryFn: getCuratedContent });
